import React, { useState } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission } from '../utils/permissions';
import './Layout.css';
import RecentViewedFloating from './RecentViewedFloating';

const Layout = () => {
    const { user, logout } = useAuth();
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const navigation = [
        { name: '계약 관리', path: '/contracts', permission: 'CONTRACT_VIEW' },
        { name: '해약 관리', path: '/cancellations', permission: 'CONTRACT_VIEW' },
        { name: '이장 관리', path: '/relocations', permission: 'CONTRACT_VIEW' },
        { name: '미확인 계약', path: '/unseen-contracts', permission: 'CONTRACT_VIEW' },
        { name: '통계 관리', path: '/statistics', permission: 'STATISTICS_VIEW' },
        { name: '방문자 목록', path: '/visitor-history', permission: 'CONTRACT_VIEW' },
        { name: '키오스크 App 다운로드', path: '/app-download', permission: 'CONTRACT_VIEW' },
        { name: '관리자 페이지', path: '/admin-settings', permission: 'ADMIN_PAGE_ACCESS' },
        { name: '사용자 관리', path: '/users', permission: 'USER_MANAGE' },
        { name: '묘지 관리', path: '/cemeteries', permission: 'CEMETERY_VIEW' },
    ];

    const handleLogout = () => {
        logout();
    };

    const toggleSidebar = () => {
        console.log('🔧 사이드바 토글 - 현재 상태:', isSidebarOpen);
        const newState = !isSidebarOpen;
        console.log('🔧 사이드바 토글 - 새로운 상태:', newState);
        setIsSidebarOpen(newState);
    };

    const closeSidebar = () => {
        console.log('🔧 사이드바 닫기');
        setIsSidebarOpen(false);
    };

    // 사용자 권한에 따라 네비게이션 항목 필터링
    const filteredNavigation = navigation.filter(item => {
        if (item.permission && !hasPermission(user?.role, item.permission)) {
            return false;
        }
        return true;
    });

    return (
        <div className="layout">
            {/* 모바일 오버레이 */}
            {isSidebarOpen && (
                <div className="sidebar-overlay" onClick={closeSidebar}></div>
            )}

            {/* 모바일 햄버거 버튼 */}
            <button className="mobile-menu-btn" onClick={toggleSidebar}>
                <span className="hamburger"></span>
            </button>

            {/* 사이드바 */}
            <aside className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                <div className="sidebar-header">
                    <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img 
                            src="/logo.png" 
                            alt="묘원365 로고" 
                            style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                        />
                        <h1 style={{ margin: 0 }}>묘원365</h1>
                    </div>
                    <button className="close-sidebar-btn" onClick={closeSidebar}>
                        ×
                    </button>
                </div>

                <nav className="sidebar-nav">
                    {filteredNavigation.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                            onClick={closeSidebar}
                        >
                            <span className="nav-text">{item.name}</span>
                        </Link>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-info">
                        {/* <div className="user-avatar">
                            {user?.name?.charAt(0) || 'U'}
                        </div> */}
                        <div className="user-details">
                            <div className="user-name">
                                <span className="user-name-text">{user?.name || '사용자'}</span>
                                {((user?.idString != null && String(user.idString).trim() !== '') ||
                                    (user?.id_string != null && String(user.id_string).trim() !== '') ||
                                    user?.id != null) && (
                                    <span className="user-id-inline">
                                        ({user?.idString ?? user?.id_string ?? user?.id})
                                    </span>
                                )}
                            </div>
                            <div className="user-role">
                                {user?.role === 'admin' ? '관리자' :
                                 user?.role === 'manager' ? '매니저' :
                                 user?.role === 'staff' ? '직원' : '사용자'}
                            </div>
                        </div>
                    </div>
                    <button className="logout-btn" onClick={handleLogout}>
                        로그아웃
                    </button>
                </div>
            </aside>

            {/* 메인 콘텐츠 */}
            <main className="main-content">
                <Outlet />
                <RecentViewedFloating />
            </main>
        </div>
    );
};

export default Layout;